import React from 'react'
import MainContentSubAccessories from '../MainContentSubAccessories'

const WaterproofBagSub = () => {
  return (
    <div className='pageAccessories bg-accessories-sub-page'>
        <MainContentSubAccessories parentCate={'Phụ kiện'}  
            childCate={'Túi chống nước'} 
            // listProduct={listProductSub}
    />
</div>
  )
}

export default WaterproofBagSub
